import {
    Email as EmailIcon,
    Phone as PhoneIcon,
    LocationOn as LocationIcon,
    Facebook,
    Twitter,
    LinkedIn,
    Instagram,
  } from "@mui/icons-material";
  
  import { Box, Typography, Grid, IconButton } from "@mui/material";
  import logo from "../assets/logo.png"; // your figma asset
  
  export default function Footer() {
    const scrollToSection = (id) => {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    };
  
    return (
      <Box
        component="footer"
        sx={{
          backgroundColor: "#111827",
          color: "#d1d5db",
          pt: 8,
          pb: 4,
        }}
      >
        <Box sx={{ maxWidth: "1200px", mx: "auto", px: 3 }}>
          {/* Main Footer Content */}
          <Grid container spacing={{xs:2,md:6}} sx={{ mb: 8 }}>
            {/* Logo + About */}
            <Grid item size={{xs:12,md:3}}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2 }}>
                <Box component="img" src={logo} sx={{ width: 40, height: 40 }} />
                <Typography sx={{ color: "#fff", fontSize: "1.1rem" }}>
                  Spendifyr
                </Typography>
              </Box>
  
              <Typography sx={{ fontSize: "0.9rem", color: "#9ca3af" }}>
                Smart expense tracking made simple. Take control of your financial
                future with our intuitive app.
              </Typography>
  
              {/* Social Icons */}
              <Box sx={{ display: "flex", gap: 2, pt: 3 }}>
                {[Facebook, Twitter, LinkedIn, Instagram].map((Icon, i) => (
                  <IconButton
                    key={i}
                    sx={{
                      width: 36,
                      height: 36,
                      backgroundColor: "#1f2937",
                      borderRadius: "50%",
                      "&:hover": {
                        backgroundColor: "#2E5E3A",
                      },
                    }}
                  >
                    <Icon sx={{ fontSize: 18, color: "#fff" }} />
                  </IconButton>
                ))}
              </Box>
            </Grid>
  
            {/* Quick Links */}
            <Grid item size={{xs:12,md:3}}>
              <Typography
                sx={{ color: "#fff", fontWeight: 600, mb: 2, fontSize: "1rem" }}
              >
                Quick Links
              </Typography>
  
              {[
                { label: "Home", id: "home" },
                { label: "How This Works", id: "how-this-works" },
                { label: "Contact Us", id: "contact-us" },
                { label: "Privacy Policy", id: "privacy-policy" },
              ].map((item) => (
                <Typography
                  key={item.id}
                  component="button"
                  onClick={() => scrollToSection(item.id)}
                  sx={{
                    display: "block",
                    textAlign: "left",
                    background: "none",
                    border: "none",
                    color: "#d1d5db",
                    p: 0,
                    mb: 1.5,
                    cursor: "pointer",
                    fontSize: "0.9rem",
                    "&:hover": { color: "#2E5E3A" },
                  }}
                >
                  {item.label}
                </Typography>
              ))}
            </Grid>
  
            {/* Resources */}
            <Grid item size={{xs:12,md:3}}>
              <Typography
                sx={{ color: "#fff", fontWeight: 600, mb: 2, fontSize: "1rem" }}
              >
                Resources
              </Typography>
  
              {["Blog", "Help Center", "Terms of Service", "FAQs"].map((item) => (
                <Typography
                  key={item}
                  sx={{
                    mb: 1.5,
                    fontSize: "0.9rem",
                    cursor: "pointer",
                    "&:hover": { color: "#2E5E3A" },
                  }}
                >
                  {item}
                </Typography>
              ))}
            </Grid>
  
            {/* Contact Info */}
            <Grid item size={{xs:12,md:3}}>
              <Typography
                sx={{ color: "#fff", fontWeight: 600, mb: 2, fontSize: "1rem" }}
              >
                Contact Info
              </Typography>
  
              <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
                <EmailIcon sx={{ color: "#2E5E3A" }} />
                <Typography
                  component="a"
                  href="mailto:support@spendifyr.com"
                  sx={{
                    textDecoration: "none",
                    color: "#d1d5db",
                    fontSize: "0.9rem",
                    "&:hover": { color: "#2E5E3A" },
                  }}
                >
                  support@spendifyr.com
                </Typography>
              </Box>
  
              {/* <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
                <PhoneIcon sx={{ color: "#2E5E3A" }} />
                <Typography sx={{ fontSize: "0.9rem" }}>
                  +1 (555) 123-4567
                </Typography>
              </Box> */}
  
              <Box sx={{ display: "flex", gap: 2 }}>
                <LocationIcon sx={{ color: "#2E5E3A" }} />
                <Typography sx={{ fontSize: "0.9rem" }}>
                  123 Finance Street
                  <br />
                  New York, NY 10001
                </Typography>
              </Box>
            </Grid>
          </Grid>
  
          {/* Bottom Bar */}
          <Box
            sx={{
              borderTop: "1px solid #1f2937",
              pt: 3,
              mt: 5,
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              justifyContent: "space-between",
              alignItems: "center",
              gap: 3,
            }}
          >
            <Typography sx={{ fontSize: "0.85rem", color: "#9ca3af" }}>
              © 2025 Spendifyr. All rights reserved.
            </Typography>
  
            <Box sx={{ display: "flex", gap: 4 }}>
              {["Privacy Policy", "Terms of Service", "Cookie Policy"].map(
                (item) => (
                  <Typography
                    key={item}
                    sx={{
                      fontSize: "0.85rem",
                      color: "#9ca3af",
                      cursor: "pointer",
                      "&:hover": { color: "#2E5E3A" },
                    }}
                  >
                    {item}
                  </Typography>
                )
              )}
            </Box>
          </Box>
        </Box>
      </Box>
    );
  }
  